import Icon from '@tiger/icons';
import { FC } from 'react';
import { PanelContentProps } from 'components/Picker';
import styles from './style.scss';

const PanelContent: FC<PanelContentProps> = ({ options = [], value = [], onChange }) => {
    const handleSelectedRef = (node: HTMLDivElement | null) => {
        if (node) {
            // 滚动到可视区域
            node.scrollIntoView({
                behavior: 'smooth',
                block: 'nearest'
            });
        }
    };

    return (
        <div className={styles.panelRoot}>
            <div className={styles.options}>
                {options.map(option => {
                    const isActive = value[0] === option.value;

                    return (
                        <div
                            key={option.value}
                            className={styles.option}
                            ref={isActive ? handleSelectedRef : null}
                            onClick={() => {
                                onChange?.([option.value], true);
                            }}>
                            {option.label}
                            {isActive && <Icon type="check" />}
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default PanelContent;
